// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

var PaymentsExportFilesController = function ($rootScope,
    $scope,
    $http,
    PaymentsExport,
    BlEbicsAvailabilityService,
    gettext,
    gettextCatalog) {

    const EBICS_PROCESSING_STATUSES = Object.freeze({
        'NotSent': 'NotSent',
        'Rejected': 'Rejected',
        'EsVerification': 'EsVerification',
        'Accepted': 'Accepted',
        'FileDownload': 'FileDownload',
        'FileUpload': 'FileUpload',
        'VeuCancelOrder': 'VeuCancelOrder',
        'Additional': 'Additional',
        'Unmapped': 'Unmapped',
    });

    const EXPORT_TRANSACTION_TYPE = Object.freeze({
        'DirectDebit': 'DirectDebit',
        'Refund': 'Refund'
    });

    BlEbicsAvailabilityService.requestEbicsAvailableFlag();

    $scope.isUpdateRequired = false;

    $scope.isEbicsAvailable = function () {
        return BlEbicsAvailabilityService.isEbicsAvailable();
    };

    function update() {
        $scope.exports = $scope.paginator(PaymentsExport.query, {}, 20);
    }

    const TOOLTIP_TEXT = Object.freeze({
         'CancelUploadTitle' : 'Cancel Send to bank',
         'SendToBankAutoTitle' : 'Send to bank automatically',
         'SendToBankTitle' : 'Send to bank',
         'FiledTitle' : 'Upload failed',
         'UploadedTitle' : 'File already uploaded'
    });

    const UPLOAD_STATUSES = Object.freeze({
        'DidNotSend': 'DidNotSend',
        'ToBeSent': 'ToBeSent',
        'Sent': 'Sent',
        'Failed': 'Failed'
    });
    const FILE_GENERATION_STATUSES = Object.freeze({
        'InProgress': 'InProgress',
        'Queued': 'Queued',
        'DataPrepared': 'DataPrepared',
        'Finished': 'Finished',
        'DataPreparationFailed': 'DataPreparationFailed',
        'FileGenerationFailed': 'FileGenerationFailed'
    });

    const source = Rx.Observable
        .interval(10000)
        .timeInterval();

    const subscription = source.subscribe(function (x) {
        if ($scope.exports.pageIndex === 1 && isAnyItemInProgress())
            update();
    });

    $scope.$on("$destroy", function handler() {
        subscription.dispose();
        clearLocalStorage();
    });

    $scope.download = function (id) {
        $http({
            method: "POST",
            url: "/api/v1/paymentsExports/" + id + "/downloadlink",
            params: {},
            //data: $scope.parameters,
            headers: {},
            cache: false
        }).then(
            function (response) {
                var downloadInfo = response.data;
                $scope.downloadFile(downloadInfo.Url);
            },
            function (error) {
                $scope.reports = Report.query();
            });
    };

    $scope.send = function (id, command, succeededCallback) {
        $scope.isUpdateRequired = true;
        $http({
            method: "PUT",
            url: "/api/v1/paymentsExports/" + id + "/" + command,
            params: {},
            headers: {},
            cache: false
        }).then(
            function (response) {
                const expItm = $scope.updateExportItem(response);
                if (expItm) succeededCallback(expItm);
            },
            function (error) {
                $scope.reports = Report.query();
                console.error(error);
            });
    };

    $scope.updateExportItem = function (response) {
        if (response.status != 200 || !response.data) return;
        try {
            const foundElement = $scope.exports.items.find(({Id}) => Id === response.data.Id);
            if (!foundElement) {
                console.error("Can't refresh paymentExport DOM element: " + response.data.Id);
            }
            return Object.assign(foundElement, response.data);
        } catch (e) {
            console.error("Can't refresh paymentExport DOM element: " + e);
        }
    };

    $scope.isInProgress = function (paymentExport) {
        return paymentExport.Status === FILE_GENERATION_STATUSES.InProgress
            || paymentExport.Status === FILE_GENERATION_STATUSES.Queued
            || paymentExport.Status === FILE_GENERATION_STATUSES.DataPrepared;
    };

    $scope.isFileNotSentYet = function (paymentExport) {
        return !paymentExport.EbicsUploadStatus
            || paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.DidNotSend
            || paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.ToBeSent
            || isFailedAndRetryAvailable(paymentExport);
    };

    function confirm(header, paymentExportErrorMessage) {
        $scope.onlyOk(header, gettextCatalog.getString(gettext(paymentExportErrorMessage)));
    }

    $scope.showSpecificError = function(errorMessage) {
        confirm(gettextCatalog.getString(gettext('Error!')), errorMessage);
    };

    $scope.updateTitle = function(evt, text) {
        var elem = angular.element(evt.currentTarget);
        if (!elem || elem.length < 1 || !elem[0].attributes) return;
        elem[0].setAttribute('title', text);
    };

    var isFileSendingCancelOrFail = function (paymentExport) {
        return !paymentExport.EbicsUploadStatus
        || paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.DidNotSend
        || isFailedAndRetryAvailable(paymentExport);
    };

    $scope.sendClicked = function ($event, paymentExport) {
        if (paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.ToBeSent)
            $scope.send(paymentExport.Id, 'cancelFileToBeSent',(updatedPayExp) => $scope.updateTitle($event, TOOLTIP_TEXT.SendToBankTitle) );

        if (isFileSendingCancelOrFail(paymentExport))
            $scope.send(paymentExport.Id, "sendFile",
                (updatedPayExp) => $scope.updateTitle($event,
                    $scope.isInProgress(updatedPayExp)
                        ? TOOLTIP_TEXT.CancelUploadTitle
                        : TOOLTIP_TEXT.SendToBankAutoTitle
                ) );
    };

	var isFailedAndRetryAvailable = function(paymentExport)
	{
        //TODO: IT-9983 retry count check
		return paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.Failed;
	}

    $scope.getTitle = function (paymentExport) {
        if  (paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.ToBeSent)
            return TOOLTIP_TEXT.CancelUploadTitle;

        if  (isFileSendingCancelOrFail(paymentExport)) {
            if ($scope.isInProgress(paymentExport))
                return TOOLTIP_TEXT.SendToBankAutoTitle;
            else
                return TOOLTIP_TEXT.SendToBankTitle;
        }
        if  (paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.Sent)
            return TOOLTIP_TEXT.UploadedTitle;

        if  (!isFailedAndRetryAvailable(paymentExport))
            return TOOLTIP_TEXT.FiledTitle;

        return '';
    };

    $scope.getCommonStatus = function(paymentExport) {

        if (!paymentExport.EbicsUploadStatus
            || paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.ToBeSent
            || paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.DidNotSend)
        {
            return paymentExport.Status;
        }

        if (paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.Failed)
        {
            return UPLOAD_STATUSES.Failed;
        }

        const processingStatuses = paymentExport.EbicsUploadXmlFileStatuses.map(a => a.BankStatus);

        if(processingStatuses.includes(EBICS_PROCESSING_STATUSES.NotSent))
        {
            return EBICS_PROCESSING_STATUSES.NotSent;
        }

        if(processingStatuses.includes(EBICS_PROCESSING_STATUSES.FileUpload))
        {
            return EBICS_PROCESSING_STATUSES.FileUpload;
        }

        if(processingStatuses.includes(EBICS_PROCESSING_STATUSES.FileDownload))
        {
            return EBICS_PROCESSING_STATUSES.FileDownload;
        }

        if(processingStatuses.includes(EBICS_PROCESSING_STATUSES.Rejected))
        {
            return EBICS_PROCESSING_STATUSES.Rejected;
        }

        if(processingStatuses.includes(EBICS_PROCESSING_STATUSES.EsVerification))
        {
            return EBICS_PROCESSING_STATUSES.EsVerification;
        }

        if(processingStatuses.includes(EBICS_PROCESSING_STATUSES.Accepted))
        {
            return EBICS_PROCESSING_STATUSES.Accepted;
        }

        return EBICS_PROCESSING_STATUSES.NotSent; // all other statues are not connected to export file processing
    }

    $scope.isGenerationFailed = function (paymentExport) {
        return paymentExport.Status === FILE_GENERATION_STATUSES.DataPreparationFailed
            || paymentExport.Status === FILE_GENERATION_STATUSES.FileGenerationFailed;
    };

    $scope.getSendIconClass = function (paymentExport) {
        if  (isFileSendingCancelOrFail(paymentExport))
            return 'icon-send-file';

        if  (paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.ToBeSent) {
            if (paymentExport.cancelToBeSent === true)
                return 'icon-cancel-tobe-send-file';
            else
                return 'icon-tobe-send-file';
        }

        return 'icon-send-file';
    };

    $scope.togglePaymentExportInfoVisibility = function(paymentExportItem) {
        paymentExportItem.show = !paymentExportItem.show;
		if(paymentExportItem.show)
		{
			localStorage.setItem(paymentExportItem.Id, true);
		}
		else
		{
			localStorage.removeItem(paymentExportItem.Id);
		}
    };

	$scope.isExpanded = function(paymentExportItem)
	{
		paymentExportItem.show = (localStorage.getItem(paymentExportItem.Id) !== null);
		return paymentExportItem.show;
	}

    $scope.statusClass = function (status) {
        switch (status) {
            case FILE_GENERATION_STATUSES.Finished:
            case EBICS_PROCESSING_STATUSES.Accepted:
                return "label-success";
            case FILE_GENERATION_STATUSES.DataPreparationFailed:
            case FILE_GENERATION_STATUSES.FileGenerationFailed:
            case UPLOAD_STATUSES.Failed:
            case EBICS_PROCESSING_STATUSES.NotSent:
            case EBICS_PROCESSING_STATUSES.Rejected:
                return "label-important";
            default:
                return "";
        }
    };

    $scope.ShowReadableEbicsUploadStatus = function (status) {
        switch (status) {
            case UPLOAD_STATUSES.Failed:
                return gettextCatalog.getString(gettext("Sending Error"));
            case EBICS_PROCESSING_STATUSES.NotSent:
                return gettextCatalog.getString(gettext("Not Sent"));
            case EBICS_PROCESSING_STATUSES.FileUpload:
            case EBICS_PROCESSING_STATUSES.EsVerification:
                return gettextCatalog.getString(gettext("In Progress"));
            case FILE_GENERATION_STATUSES.FileGenerationFailed:
            case FILE_GENERATION_STATUSES.DataPreparationFailed:
                return gettextCatalog.getString(gettext("Generation Error"));
            default:
                return status;
        }
    };

    $scope.hoverIn = function(paymentExport){
        paymentExport.cancelToBeSent = true;
    };

    $scope.hoverOut = function(paymentExport){
        paymentExport.cancelToBeSent = false;
    };

    $scope.IsAnyEbicsSendStatusesExist = function(exportItem)
    {
        return exportItem.EbicsUploadXmlFileStatuses && exportItem.EbicsUploadXmlFileStatuses.length > 0;
    }

    $scope.isSendingFailed = function(statusValue)
    {
        return statusValue === UPLOAD_STATUSES.Failed;
    }

    update();

    $scope.getActorName = function(item){
        return item.UserName ? item.UserName : _txt("System");
    }

	const clearLocalStorage = function () {
		var savedExportsIds = $scope.exports.items
		.filter(x => x.show)
		.map(x => x.Id);
		savedExportsIds.forEach(id => {
			localStorage.removeItem(id);
		});
	}

    const isAnyItemInProgress = function() {
        for(var i = 0; i < $scope.exports.items.length; i++) {
            if($scope.isInProgress($scope.exports.items[i])
                || isFileInEbicsProgress($scope.exports.items[i])
                || isInBankProcessing($scope.exports.items[i])
                || $scope.isUpdateRequired )
            {
                $scope.isUpdateRequired = false;
                return true;
            }
        }
        $scope.isUpdateRequired = false;
        return false;
    };

    const isEbicsUploadStatusExist = function(item) {
        var result = !!item.EbicsUploadStatus;
        return result;
    }

    const isInBankProcessing = function(item) {
        var result = $scope.getCommonStatus(item) === EBICS_PROCESSING_STATUSES.EsVerification;
        return result;
    }

    const isFileInEbicsProgress = function (paymentExport) {
        var result = isEbicsUploadStatusExist(paymentExport) && (paymentExport.EbicsUploadStatus === UPLOAD_STATUSES.ToBeSent );
        return result;
    };

    function _txt(msg) {
        return gettextCatalog.getString(msg);
    }
};
PaymentsExportFilesController.$inject = ["$rootScope", "$scope", "$http", "PaymentsExport", "BlEbicsAvailabilityService",'gettext', 'gettextCatalog'];
